import { createAction } from '@reduxjs/toolkit';

import { LOAD_OWNER_INFO } from './actionTypes';

export const loadOwnerInfo = createAction<string>(LOAD_OWNER_INFO.BASE);
